<template>
  <div>
    <el-card
      v-for="(product, index) of products"
      :key="product.id"
      class="product-card"
      style="margin-bottom: 30px;"
    >
      <!-- Product previw -->
      <div class="product-image-wrapper">
        <!-- Product image -->
        <img :src="product.photo | resize(500)" class="image product-image" />

        <!-- Product product info -->
        <div class="product-image-info-wrapper">
          <h1 class="product-image-info-title">{{ product.name }}</h1>
          <h3 class="product-image-info-description">
            <span>Budget: {{ product.price }} AED</span>
            <span v-if="product.sku">/ Article {{ product.sku }}</span>
          </h3>
        </div>

        <!-- Timer control panel -->
        <div class="product-image-control-wrapper">
          <!-- <p class="product-image-control-text">{{ product.florist_time_use }} секунд</p>
          <el-button
            type="danger"
            :disabled="!product.florist_started"
            @click="productTimer('stop', product.id, index)"
          >Стоп</el-button>
          <el-button
            type="success"
            :loading="product.florist_started"
            @click="productTimer('start', product.id, index)"
          >Старт</el-button>-->
        </div>
      </div>
      <div v-if="product.package.sku">
        <h3 class="product-image-info-description" style="color:red;">
          Packaging: {{ product.package.sku }}
          <img
            :src="product.package.photo"
            style="display: block; width: 200px; border-radius: 1em;"
          />
        </h3>
      </div>

      <!-- product positions (complections) -->
      <el-table
        :data="product.positions"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column prop="name" label="Composition" width="250">
          <template slot-scope="scope">
            <div class="product-position-info">
              <p>{{ scope.row.name }}</p>
              <p v-if="!warehouses[scope.row.guid]" class="danger">
                NO WAREHOUSE DATA
              </p>
              <p v-if="!warehouses[scope.row.guid]">{{ scope.row.guid }}</p>
              <div style="opacity: .5">
                <p>Price: {{ scope.row.price }} AED</p>
                <!-- <p>Article {{ scope.row.sku }}</p> -->
                <p v-if="scope.row.need >= 1">
                  <span
                    :class="[
                      { success: scope.row.amount == scope.row.need },
                      { warning: scope.row.amount > scope.row.need },
                      { info: scope.row.amount < scope.row.need }
                    ]"
                  >
                    Recipe: {{ scope.row.need }} qt.
                    <span v-show="scope.row.amount == scope.row.need">
                      <i class="el-icon-success"></i>
                    </span>
                  </span>

                  <span
                    v-if="
                      warehouses[scope.row.guid] &&
                        warehouses[scope.row.guid].main > 0
                    "
                  >
                    <span
                      v-if="scope.row.amount > scope.row.need"
                      class="warning"
                    >
                      <i class="el-icon-warning"></i>
                      Extra {{ (scope.row.amount - scope.row.need) | roundUp }}
                    </span>
                    <span v-if="scope.row.amount < scope.row.need" class="info">
                      <i class="el-icon-info"></i>
                      More {{ (scope.row.need - scope.row.amount) | roundUp }}
                    </span>
                  </span>
                </p>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="amount" label="Amount" width="240">
          <template slot-scope="scope">
            <div v-if="warehouses[scope.row.guid]">
              <el-input-number
                v-model="scope.row.amount"
                :min="-1"
                :precision="1"
                :step="1"
                :max="
                  scope.row.added
                    ? warehouses[scope.row.guid].main +
                      warehouses[scope.row.guid].personal
                    : warehouses[scope.row.guid].main
                "
                style="width: 150px;"
                v-show="!scope.row.added"
                @change="onChangeAmount($event, scope, index)"
              />
              <h2 v-show="scope.row.added" style="margin: 0; line-height: 40px">
                {{ scope.row.amount }} qt.
              </h2>

              <p v-loading="loadingWarehouse" class="amount__line">
                <span v-if="warehouses[scope.row.guid].main <= 0">
                  <span v-if="scope.row.added">You took the last</span>
                  <span v-else class="danger">- No remainings -</span>
                </span>
                <span v-else
                  >Remaining: {{ warehouses[scope.row.guid].main }} qt.</span
                >
              </p>
            </div>
            <div v-else>
              <el-button type="danger" @click="removePosition(scope, index)"
                >Remove</el-button
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Total">
          <template slot-scope="scope">
            <strong>{{ scope.row.price * scope.row.amount }}</strong> AED
          </template>
        </el-table-column>

        <el-table-column width="70">
          <template slot-scope="scope">
            <div v-if="warehouses[scope.row.guid]">
              <el-switch
                v-model="scope.row.added"
                :disabled="
                  ((warehouses[scope.row.guid].main <= 0 ||
                    scope.row.amount <= 0) &&
                    !scope.row.added) ||
                    loadingWarehouse
                "
                v-show="
                  !(!scope.row.added && warehouses[scope.row.guid].main <= 0)
                "
                @change="warehouseTransfer($event, scope.row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-button
        @click="addPosition(product, index)"
        style="width: 100%; border: 0; border-radius: 0; padding: 16px 20px;"
        type="primary"
        >Add position
      </el-button>
      <h3 style="text-align: center;">Add photo for {{ product.name }}</h3>
      <el-upload
        style="display: flex; justify-content: center; margin-top: 15px;"
        :key="`${orderID}_${product.guid}_${index}`"
        :action="uploadUrl"
        list-type="picture-card"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :data="{ orderID, productGUID: product.guid, pos: index }"
        :headers="{ Authorization: token }"
        :file-list="product.images"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-card>
  </div>
</template>

<script>
import api from "@/api/order";
import { getUrl } from "@/api";

const uploadUrlPhoto = getUrl("Photo.upload");

export default {
  data: () => ({
    uploadUrl: uploadUrlPhoto
  }),
  computed: {
    token() {
      return localStorage.getItem("token");
    }
  },
  props: {
    products: Array,
    warehouses: Object,
    orderID: Number,
    isLoading: Boolean,
    loadingWarehouse: Boolean
  },
  filters: {
    roundUp: function(val) {
      if (val % 1 === 0) {
        return val;
      }
      return val.toFixed(1);
    }
  },
  methods: {
    handleRemove(file) {
      this.$emit("removePhoto", file.name);
      api.RemovePhoto(file.name);
    },
    handleSuccess(response) {
      this.$emit("addPhoto", {
        index: response.data.pos,
        image: {
          name: response.data.name,
          status: "success",
          uid: response.data.guid,
          url: response.data.url
        }
      });
    },
    productTimer(action, productId, productIndex) {
      console.log(action, productId, productIndex);
    },
    addPosition(product, index) {
      this.$emit("addPosition", product, index);
    },
    onChangeAmount(currentValue, scope, productIndex) {
      if (currentValue <= 0) {
        const positionName = scope.row.name;
        this.$confirm(
          `Remove <strong>${positionName}</strong> ?`,
          "Something is extra?",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Remove",
            cancelButtonText: "Keep",
            type: "warning"
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              dangerouslyUseHTMLString: true,
              message: `<strong>${positionName}</strong> removed from composition`
            });
            this.products[productIndex].positions.splice(scope.$index, 1);
          })
          .catch(() => {
            scope.row.amount = 1;
          });
      }
    },
    removePosition(scope, index) {
      this.products[index].positions.splice(scope.$index, 1);
    },
    warehouseTransfer(value, row) {
      if (
        value &&
        row.need &&
        (row.amount < row.need || row.amount > row.need)
      ) {
        const positionName = row.name;

        const title = row.amount > row.need ? "TOO MUCH" : "NOT ENOUGH";
        this.$confirm(
          `<br><p>Requires <strong>${
            row.need
          } qt.</strong> ${positionName},</p><p>while you are taking only <strong>${
            row.amount
          } qt.</strong></p><br>`,
          `Something ${title} ...`,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: `Use ${row.amount} qt.`,
            cancelButtonText: `Cancel`,
            type: "warning"
          }
        )
          .then(() => {
            this.$notify({
              type: "warning",
              message: "On one's own risk!",
              title: "Danger!",
              position: "bottom-right"
            });

            api
              .transferProduct(value, this.orderID, row.guid, row.amount)
              .then(r => {
                let result = r.data;

                if (!result.success) {
                  this.$message.error(result.message);
                  row.added = false;
                } else {
                  this.$emit("updateWarehouse");
                }
              });
          })
          .catch(() => {
            row.added = false;
          });
      } else if (value) {
        api
          .transferProduct(value, this.orderID, row.guid, row.amount)
          .then(r => {
            let result = r.data;

            if (!result.success) {
              this.$message.error(result.message);
              row.added = false;
            } else {
              this.$emit("updateWarehouse");
            }
          });
      }

      if (!value) {
        api.transferProduct(value, this.orderID, row.guid, row.amount);
        this.$emit("updateWarehouse");
      }
    },
    getSummaries(param) {
      const { data } = param;
      let pure = 0;
      let dirty = 0;

      data.forEach(row => {
        if (row.added) {
          pure += row.amount * row.price;
        }
        dirty += row.amount * row.price;
      });

      let dirtyRow = dirty == pure ? "" : `Draft: ${dirty} AED`;
      return ["", dirtyRow, `Total: ${pure} AED`];
    }
  },
  watch: {
    products: {
      handler(composition) {
        if (this.isLoading) return;
        api.updateComposition(composition, this.orderID);
      },
      deep: true
    }
  }
};
</script>

<style>
.product-card .el-card__body {
  padding: 0 !important;
  margin-bottom: 20px;
}

.product-image {
  max-width: 100%;
}

.product-image-wrapper {
  position: relative;
}

.product-image-info-wrapper {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 90%;
}

.product-image-info-title {
  margin: 5px;
  margin-left: 10px;
}

.product-image-info-description {
  margin: 5px;
  margin-left: 10px;
}

.product-image-control-wrapper {
  position: absolute;
  bottom: 13px;
  right: 10px;
}

.product-image-control-text {
  color: #fff;
  display: inline-block;
  margin-right: 10px;
}

.danger {
  color: red;
}

.warning {
  color: orange;
}

.success {
  color: green;
}

.info {
  color: blue;
}

.product-position-info p {
  margin: 0 !important;
}

.amount__line {
  margin: 2px;
  opacity: 0.5;
}

td.el-table_1_column_2.is-leaf > div {
  opacity: 0.5 !important;
}
</style>
